import { render, staticRenderFns } from "./ChoiceRadio.vue?vue&type=template&id=1ebf0506&scoped=true&"
import script from "./ChoiceRadio.vue?vue&type=script&lang=js&"
export * from "./ChoiceRadio.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceRadio.vue?vue&type=style&index=0&id=1ebf0506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf0506",
  null
  
)

export default component.exports